module.exports = __webpack_public_path__ + "static/media/3-item-b.b59f663f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/3-item-b.jpg
// module id = 1163
// module chunks = 33